module.exports = __webpack_public_path__ + "img/pic_turbomode_speed2@3x.675bd18c.png";